import React, { useEffect } from "react";
import "../Home/Home.css";
import { motion as m } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";
import { BsLinkedin } from "react-icons/bs";

const OurTeam = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ourTeam_data = [
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fd7aef07-e913-4ec3-be34-b6792fd00900/public", // Init_sikandar.webp
      name: "Mr. Sikandar Bathvar",
      position: "Director",
      linkedin: "https://www.linkedin.com/in/sikandar-bathvar-5a2b46154/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/59cdec0c-5008-4608-540a-ddd9e70be700/public", // Init_naju.webp
      name: "Ms. Naju Keshwala",
      position: "Director",
      linkedin: "https://www.linkedin.com/in/naju-keshwala-37075912a/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/30b18742-5397-42ff-1e14-5a187ae44100/public", // Init_areebah.webp
      name: "Ms. Areebah Kadri",
      position: "Front-end Developer",
      linkedin: "https://www.linkedin.com/in/areebah-k-059150244/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/06f1dbd3-a23a-4ba9-5aa7-e1ebe5a24500/public", // Init_dhruvi.webp
      name: "Ms. Dhruvi Joshi",
      position: "Back-end Developer",
      linkedin: "https://www.linkedin.com/in/dhruvi-joshi-925359245/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f93bebf2-5502-4d6c-d108-e09c710e3600/public", // Init_pranjal.webp
      name: "Ms. Pranjal Dharwad",
      position: "SEO Expert",
      linkedin: "/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b4a43ac2-4ab3-47d1-0b85-f460f74b9400/public", // Init_ramiz.webp
      name: "Mr. Ramiz Ghada",
      position: "Back-end Developer",
      linkedin: "https://www.linkedin.com/in/ramiz-ghada-4230a4358/",
    },
    {
      img: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4d7e3b3f-bb02-4aa8-8336-9ca369e81e00/public", // Init_shweta.webp
      name: "Ms. Shweta Ranva",
      position: "Front-end Developer",
      linkedin: "https://www.linkedin.com/in/shweta-ranva-6a92b0366/",
    },
  ];

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-32">
          <div className="card_titleBanner relative w-full pt-14 pb-12 group rounded-lg overflow-hidden flex flex-col bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold transition-all duration-300 ease-in-out">
            <div className="flex flex-col sm:items-center">
              <p className="font-semibold uppercase text-3xl lg:text-4xl transition-all duration-200 ease-in-out">
                Our Team
                <div className="flex h-0.5 w-10 mt-0.5 bg-teal-600 rounded-full" />
              </p>

              <p className="flex items-center gap-1 mt-3 text-sm">
                Home <IoIosArrowForward className="text-teal-600" />
                <i>Our Team</i>
              </p>
            </div>
          </div>
        </div>

        {/* Team grid */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-10">
            {ourTeam_data.map((member, index) => (
              <div
                key={index}
                className="group bg-white dark:bg-[#252525]  border-transparent hover:border-teal-600/40 p-5 shadow-md hover:shadow-custom dark:hover:shadow-white rounded-lg flex flex-col transition-all duration-300 ease-in-out"
              >
                <img
                  src={member.img}
                  alt="member-Img"
                  className="w-full aspect-[1/1] object-center object-cover rounded-md group-hover:rounded-[50%] group-hover:scale-105 transition-all duration-500 ease-in-out"
                  loading="lazy"
                />

                <div className="flex justify-between items-end p-1 mt-3">
                  <div>
                    <p className="font-medium text-base 2xl:text-xl">
                      {member.name}
                    </p>

                    <p className="text-sm 2xl:text-lg mt-1">
                      {member.position}
                    </p>
                  </div>

                  <a href={member.linkedin} target="_blank" rel="noreferrer">
                    <BsLinkedin
                      size={20}
                      className="hover:scale-110 hover:text-[#008080] transition-all duration-300 ease-linear"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default OurTeam;
